[
  {
    "code": "KW-AH",
    "name": "Al Ahmadi"
  },
  {
    "code": "KW-FA",
    "name": "Al Farwaniyah"
  },
  {
    "code": "KW-JA",
    "name": "Al Jahrah"
  },
  {
    "code": "KW-KU",
    "name": "Al Kuwayt"
  },
  {
    "code": "KW-HA",
    "name": "Hawalli"
  },
  {
    "code": "KW-MU",
    "name": "Mubarak al Kabir"
  }
]